// Shared site constants & content for Farmico International Trading FZE / Farmico Proteins FZCO
export const COMPANY = {
  groupName: "FARMICO Group",
  fze: "Farmico International Trading FZE",
  fzco: "Farmico Proteins FZCO",
  fzeUpper: "FARMICO INTERNATIONAL TRADING FZE",
  fzcoUpper: "FARMICO PROTEINS FZCO",
  tagline: "Sourcing the world's pulses and oilseeds.",
  baseLocation: "Dubai, United Arab Emirates",
  address: "816, Tower A, Jafza One, Jebel Ali Free Zone, Dubai, UAE",
  phone: "+971 4 459 9808",
  whatsapp: "+971 52 523 2695",
  email: "akshay@farmicoproteins.com",
  hours: "Mon – Fri · 09:00 – 18:00 GST",
  mapsUrl:
    "https://www.google.com/maps/place/FARMICO+INTERNATIONAL+TRADING+FZE/@24.9642314,55.080466,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f6db27d352f4f:0x6ec8c73e35678abb!8m2!3d24.9642314!4d55.080466!16s%2Fg%2F11sy1k_rvp",
  mapsEmbed:
    "https://www.google.com/maps?q=24.9642314,55.080466&z=17&output=embed",
  logo: "/farmico-logo.png",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/brokerage", label: "Brokerage" },
  { to: "/quality", label: "Quality" },
  { to: "/global-presence", label: "Global Presence" },
  { to: "/contact", label: "Contact" },
];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/17adc54e-8942-4dc1-8d93-5e59998c6f94/images/048e147072c88c617b8d057ce5c9ae020125eb1cb3528693eb63d22bdc851346.png",
  pulses: "/images/pigeon_peas_actual.jpg",
  pulsesLentils: "/images/lentils_actual.jpg",
  pulsesCombo: "/images/pulses_pigeon_lentils_final.jpg",
  pulsesSecondary: "/images/pulses_secondary.jpg",
  pulsesMungBrownEye: "/images/pulses_mung_browneye.jpg",
  pulsesPigeonRefined: "/images/pigeon_peas_refined.jpg",
  oilseeds: "/images/oilseeds_hero.jpg",
  network: "https://static.prod-images.emergentagent.com/jobs/17adc54e-8942-4dc1-8d93-5e59998c6f94/images/bc8adbf56b4fa2cb90e16bd21fb8733f250cdce5676de804ba8d73119185fe18.png",
  harvest: "https://images.pexels.com/photos/9963133/pexels-photo-9963133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  shipping: "https://images.unsplash.com/photo-1604506522146-316c8bedd874?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  lentils: "https://images.unsplash.com/photo-1763368392508-3d4bddfdd20a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  warehouse: "https://images.pexels.com/photos/9963133/pexels-photo-9963133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cotton: "https://images.unsplash.com/photo-1599394022918-6c2776530abb?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
};

export const PRODUCTS = [
  {
    slug: "pulses",
    name: "Pulses",
    image: IMAGES.pulsesCombo,
    secondaryImage: IMAGES.pulsesSecondary,
    tertiaryImage: IMAGES.pulsesMungBrownEye,
    summary:
      "From African Pigeon Peas to Canada Lentils, we trade pulses across every major origin and grade.",
    items: [
      "Pigeon Peas (Tur)",
      "Black Matpe (Urad)",
      "Red & Green Lentils",
      "Chick Peas (Kabuli, Desi)",
      "Yellow & Green Peas",
      "Mung Beans",
      "Brown & Black Eye Beans",
      "Light Speckled Kidney Beans",
    ],
  },
  {
    slug: "oilseeds-others",
    name: "Oilseeds & Other Commodities",
    image: IMAGES.oilseeds,
    summary:
      "Trusted supply of oilseeds and select cash crops for processors, ingredient makers and traders worldwide.",
    items: ["Soya Beans", "Sesame Seeds", "Cotton"],
  },
];

export const REGIONS = [
  { region: "Indian Subcontinent", note: "India · Pakistan · Bangladesh · Sri Lanka" },
  { region: "Middle East & North Africa", note: "UAE · KSA" },
  { region: "Sub-Saharan Africa", note: "Tanzania · Malawi · Mozambique · Sudan · Kenya · Ethiopia · Nigeria" },
  { region: "Europe", note: "Türkiye · United Kingdom" },
  { region: "Americas", note: "Canada · USA · Argentina · Brazil" },
  { region: "Asia Pacific", note: "Australia · Vietnam · Singapore · China" },
];

export const STATS = [
  { value: "10+", label: "Years of trading experience" },
  { value: "25+", label: "Countries served" },
  { value: "200K MT", label: "Annual volume" },
  { value: "100+", label: "Long-standing partners" },
];
